import { render } from "./Rotate.vue?vue&type=template&id=5a213368&scoped=true&ts=true"
import script from "./Rotate.vue?vue&type=script&lang=ts"
export * from "./Rotate.vue?vue&type=script&lang=ts"

import "./Rotate.vue?vue&type=style&index=0&id=5a213368&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a213368"]])

export default __exports__